import * as effects from 'redux-saga/effects';

import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { guidanceActions } from '../../actions';
import { FillGuidanceActionPayload } from '../../typedefs';

export function* fetchGuidance() {
  try {
    yield effects.put(guidanceActions.startFetching());
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: 'guidance_tours/' },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }
    const data: FillGuidanceActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(guidanceActions.fillGuidance(data));
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(guidanceActions.stopFetching());
  }
}
